import processHtmlAttributes from "../../../common/html-attributes";
import constants from "./constants";

static function noop() {}
static var typeRoles = constants.typeRoles;
static var pointerStyles = constants.pointerStyles;

$ input.toJSON = noop;

$ var hasUserStyles = (
    input.styleTop ||
    input.styleLeft ||
    input.styleRight ||
    input.styleBottom
);
$ var overlayStyles = hasUserStyles ? {
    top: input.styleTop,
    left: input.styleLeft,
    right: input.styleRight,
    bottom: input.styleBottom
} : pointerStyles[input.pointer || "bottom"];

<span
    id=input.id
    class=`${input.type}__overlay`
    role=typeRoles[input.type]
    aria-labelledby=(
        input.type === "tourtip" &&
        input.heading &&
        component.elId("tourtip-label")
    )
    style=overlayStyles>
    <span class=`${input.type}__pointer ${input.type}__pointer--${input.pointer}`/>
    <span class=`${input.type}__mask`>
        <span class=`${input.type}__cell`>
            <span class=`${input.type}__content`>
                <if(input.heading)>
                    <span
                        ...processHtmlAttributes(input.heading)
                        class=[`${input.type}__heading`, input.heading.class]
                        id:scoped="tourtip-label">
                        <${input.heading.renderBody}/>
                    </span>
                </if>
                <if(input.content)>
                    <${Object.keys(input.content).length > 1 && "span"}
                        ...processHtmlAttributes(input.content)>
                        <${input.content.renderBody}/>
                    </>
                </if>
            </span>
            <if(input.type !== "tooltip")>
                <button
                    aria-label=input.a11yCloseText
                    class=['icon-btn', `${input.type}__close`]
                    type="button"
                    onClick("handleCloseButton")>
                    <ebay-close-icon/>
                </button>
            </if>
        </span>
    </span>
</span>
